import 'tslib';
import 'long';
import '../proto/index.js';
import '../core/consts.js';
import '../core/metrics/logger.js';
import '../core/metrics/monitor.js';
import '../core/service/RuntimeContext.js';
import '../core/network/NetworkItem.js';
import 'json-long';
import 'moize';
import '../core/model/Message.js';
import 'js-md5';
import '../core/utils/lz4.js';
import '../core/utils/serializer.js';
import '../adapter/manager/AdapterManager.js';
import '../adapter/manager/types.js';
import '../core/utils/ticker.js';
import '../adapter/abstract/IMNetApi.js';
import '../core/options.js';
import '../core/utils/uuid.js';
import '../core/service/ConversationManager.js';
import '../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../core/plugin/DbProxy.js';
import '../core/metrics/trackerTypes.js';
import { BasePlugin } from '../core/plugin/BasePlugin.js';
import '../core/model/CommandMessage.js';
import { emojiMap } from './res/emojiMap.js';

const emojiNameRegex = /\[([a-zA-Z0-9\u4e00-\u9fa5]+)\]/g;
class EmojiPlugin extends BasePlugin {
    install() {
        this.instance.emojify = this.extendFunc(this.emojify);
        this.instance.randomEmoji = this.extendFunc(this.randomEmoji);
        this.instance.getAllEmoji = this.extendFunc(this.getAllEmoji);
    }
    /**
     * 将消息中的表情为base64
     * @param params.str 消息
     * @param params.onMissing
     * @param params.format 业务自定义处理函数
     */
    emojify(params) {
        if (!params.str) {
            return '';
        }
        return params.str
            .split(emojiNameRegex)
            .map((s, i) => {
            if (i % 2 === 0) {
                return s;
            }
            const emojiText = this.wrapEmoji(s);
            const emojiRes = this.getEmojiResName(emojiText);
            if (!emojiRes && typeof params.onMissing === 'function') {
                return params.onMissing(s);
            }
            if (emojiRes && typeof params.format === 'function') {
                return params.format(emojiText, emojiRes);
            }
            return emojiText;
        })
            .join('');
    }
    /**
     * 返回一个随机的emoji
     */
    randomEmoji() {
        const emojiKeys = Object.keys(emojiMap);
        const randomIndex = Math.floor(Math.random() * emojiKeys.length);
        const key = emojiKeys[randomIndex];
        const emoji = this.getEmojiResName(key);
        return { key, emoji };
    }
    /**
     * 获取所有的emoji
     */
    getAllEmoji() {
        const res = [];
        for (const [key, value] of Object.entries(emojiMap)) {
            res[value - 1] = {
                key,
                emoji: this.getEmojiResName(key)
            };
        }
        return res;
    }
    wrapBrackets(str) {
        return str.length > 0 ? `[${str}]` : '';
    }
    wrapEmoji(str) {
        return str[0] !== ']' ? this.wrapBrackets(str) : str;
    }
    getEmojiResName(emoji) {
        if (!emojiMap[emoji]) {
            return;
        }
        const code = emojiMap[emoji];
        const imgJson = require(`./res/images/imsdk_emoji_${code}.json`);
        if (!imgJson) {
            /* istanbul ignore next */
            return;
        }
        return imgJson.text;
    }
}

export { EmojiPlugin };
//# sourceMappingURL=EmojiPlugin.js.map
